(() => {
  const initialiseSoftwareSearch = (root = document) => {
    const page = root.querySelector('[data-software-page]');

    if (!page || page.dataset.softwareSearchReady === 'true') {
      return;
    }

    const searchInput = page.querySelector('[data-software-search]');
    const clearButton = page.querySelector('[data-software-search-clear]');
    const status = page.querySelector('[data-software-search-status]');
    const noResults = page.querySelector('[data-software-no-results]');
    const categoryNav = page.querySelector('[data-software-category-nav]');
    const backToTop = page.querySelector('[data-software-back-to-top]');
    const categoryLinks = [...page.querySelectorAll('[data-software-category-link]')];
    const categories = [...page.querySelectorAll('[data-software-category]')];

    if (!searchInput || categories.length === 0) {
      return;
    }

    const updateResults = () => {
      const query = searchInput.value.trim().toLocaleLowerCase();
      let visibleProductCount = 0;

      categories.forEach((category) => {
        const categoryKey = category.dataset.softwareCategory;
        const cards = [...category.querySelectorAll('[data-software-card]')];
        let visibleCategoryCount = 0;

        cards.forEach((card) => {
          const productName = (card.dataset.softwareProduct || '').toLocaleLowerCase();
          const isMatch = query === '' || productName.includes(query);

          card.hidden = !isMatch;

          if (isMatch) {
            visibleCategoryCount += 1;
            visibleProductCount += 1;
          }
        });

        category.hidden = visibleCategoryCount === 0;

        const categoryLink = categoryLinks.find((link) => link.dataset.softwareCategoryLink === categoryKey);

        const categoryCount = category.querySelector('.software-page__category-count');

        if (categoryCount) {
          categoryCount.textContent = String(visibleCategoryCount);
        }

        if (categoryLink) {
          const categoryNavCount = categoryLink.querySelector('.software-page__category-nav-count');
          const categoryLabel = categoryLink.querySelector('span:first-child')?.textContent.trim() || categoryKey;

          if (categoryNavCount) {
            categoryNavCount.textContent = String(visibleCategoryCount);
          }

          categoryLink.setAttribute(
            'aria-label',
            `${categoryLabel} (${visibleCategoryCount} product${visibleCategoryCount === 1 ? '' : 's'})`
          );
          categoryLink.hidden = visibleCategoryCount === 0;
        }
      });

      const hasQuery = query !== '';
      const hasResults = visibleProductCount > 0;

      if (clearButton) {
        clearButton.hidden = !hasQuery;
      }

      if (status) {
        status.hidden = !hasQuery;

        if (hasQuery) {
          status.textContent = `${visibleProductCount} product${visibleProductCount === 1 ? '' : 's'} found`;
        } else {
          status.textContent = '';
        }
      }

      if (noResults) {
        noResults.hidden = hasResults;
      }

      if (categoryNav) {
        categoryNav.hidden = hasQuery && !hasResults;
      }
    };

    searchInput.addEventListener('input', updateResults);

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        searchInput.value = '';
        updateResults();
        searchInput.focus();
      });
    }

    if (backToTop) {
      const updateBackToTop = () => {
        backToTop.hidden = window.scrollY < 480;
      };

      backToTop.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });

      window.addEventListener('scroll', updateBackToTop, { passive: true });
      updateBackToTop();
    }

    page.dataset.softwareSearchReady = 'true';
    updateResults();
  };

  const initialiseFirmwareDialogs = (root = document) => {
    const dialog = root.querySelector('[data-firmware-dialog]');

    if (!dialog || dialog.dataset.firmwareReady === 'true') {
      return;
    }

    const continueLink = dialog.querySelector('[data-firmware-continue]');
    const productLabel = dialog.querySelector('[data-firmware-dialog-product]');
    const message = dialog.querySelector('[data-firmware-dialog-message]');
    const cancelButtons = dialog.querySelectorAll('[data-firmware-cancel]');
    let activeTrigger = null;

    if (!continueLink || !message || typeof dialog.showModal !== 'function') {
      return;
    }

    const closeDialog = () => {
      if (dialog.open) {
        dialog.close();
      }

      if (activeTrigger) {
        activeTrigger.focus();
        activeTrigger = null;
      }
    };

    root.querySelectorAll('[data-firmware-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        activeTrigger = trigger;
        continueLink.href = trigger.href;
        message.textContent = trigger.dataset.firmwareWarning || '';

        if (productLabel) {
          productLabel.textContent = trigger.dataset.firmwareProduct || '';
          productLabel.hidden = !productLabel.textContent;
        }

        dialog.showModal();
      });
    });

    cancelButtons.forEach((button) => {
      button.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeDialog();
      }
    });

    continueLink.addEventListener('click', () => {
      dialog.close();
      activeTrigger = null;
    });

    dialog.dataset.firmwareReady = 'true';
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialiseSoftwareSearch();
    initialiseFirmwareDialogs();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initialiseSoftwareSearch(event.target);
    initialiseFirmwareDialogs(event.target);
  });
})();
